
import { Component, Vue } from "vue-property-decorator";

import { QRScannerModule } from "@/store/qrscanner";
import { AuthModule } from "@/store/auth";
import { TicketFormRequest } from "@/store/qrscanner/types";

@Component
export default class TicketScanForm extends Vue {
  public IBONumber = "";
  public GuestPhoneNumber = "";
  public Qty = 1;
  public valid = false;
  public guestSwitch = false;
  public loadRequest = false;

  public async submit(): Promise<void> {
    let requestBody: TicketFormRequest;

    if (this.guestSwitch) {
      if (this.GuestPhoneNumber.length < 2) {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Form",
          text: `Request is unsuccessful! You must submit a valid Phone Number`,
        });
        this.$emit("errorEvent");
        return;
      }
      requestBody = {
        GuestPhoneNumber: this.GuestPhoneNumber,
        IBONumber: this.IBONumber,
        Qty: this.Qty,
        EventID: AuthModule.currentEventID,
      };
    } else {
      if (this.IBONumber.length < 2) {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Ticket Form",
          text: `Request is unsuccessful! You must submit a valid IBO Number`,
        });
        this.$emit("errorEvent");
        return;
      }
      requestBody = {
        IBONumber: this.IBONumber,
        Qty: this.Qty,
        EventID: AuthModule.currentEventID,
      };
    }
    this.loadRequest = true;
    await QRScannerModule.TicketForm(requestBody);
    const currentSuccessStatus = QRScannerModule.currentSuccessStatus;
    if (currentSuccessStatus === true) {
      this.$notify({
        group: "tickets",
        type: "success",
        title: "Ticket Form",
        text: "Request is successful!",
      });
      this.$emit("successEvent");
    } else {
      const currentErrorMessage = QRScannerModule.currentErrorMessage;
      this.$notify({
        group: "tickets",
        type: "error",
        title: "Ticket Form",
        text: `Request is unsuccessful! ${currentErrorMessage}`,
      });
      this.$emit("errorEvent");
    }
    this.loadRequest = false;
    this.GuestPhoneNumber = "";
    this.IBONumber = "";
    this.Qty = 0;
  }
}
